import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Row, Col } from "react-bootstrap";
import CmnFilters from "../../lead-management/common/CmnFilters";
import CommonStructured from "../../common-components/CommonStructured";
import { fetchBCASchedulerBroadcastLogsData } from "../../../redux/ad-blog-reducers/blogSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import BCASchedulerTemplates from "./BCASchedulerTemplates";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { formatDateTime } from "../../common-data/Converts";

const BCAScheduledBroadcastLogsStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    bcaSchedulerBroadcastLogs,
    bcaSchedulerBroadcastLogsLoading,
    bcaSchedulerBroadcastLogsError,
  } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedWPTemplate: "",
    selectedBCASchedulerCondition: "",
    isActive: "",
    selectedScheduleType: "",
    searchString: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    include_templates: "true",
    condition: allFilters.selectedBCASchedulerCondition?.value || "",
    whatsapp_template_name: allFilters.selectedWPTemplate?.value || "",
    status: allFilters.isActive?.value || "",
    condition_type: allFilters.selectedScheduleType?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const initialDatas = {
    pagination: [],
    getResults: [],
  };
  const [getAPIData, setGetAPIData] = useState(initialDatas);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getBcaSchedulerBroadcastLogs = (filters) => {
    dispatch(
      fetchBCASchedulerBroadcastLogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getBcaSchedulerBroadcastLogs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      condition: allFilters.selectedBCASchedulerCondition?.value || "",
      whatsapp_template_name: allFilters.selectedWPTemplate?.value || "",
      status: allFilters.isActive?.value || "",
      condition_type: allFilters.selectedScheduleType?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedBCASchedulerCondition,
    allFilters.selectedWPTemplate,
    allFilters.isActive,
    allFilters.selectedScheduleType,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (
      !bcaSchedulerBroadcastLogsLoading &&
      !bcaSchedulerBroadcastLogsError &&
      bcaSchedulerBroadcastLogs?.status &&
      bcaSchedulerBroadcastLogs?.data?.length > 0
    ) {
      setGetAPIData((prevs) => ({
        ...prevs,
        allData: bcaSchedulerBroadcastLogs.data,
        pagination:
          bcaSchedulerBroadcastLogs?.pagination?.length > 0
            ? bcaSchedulerBroadcastLogs.pagination
            : [],
      }));
    } else {
      setGetAPIData(initialDatas);
    }
  }, [
    bcaSchedulerBroadcastLogs,
    bcaSchedulerBroadcastLogsLoading,
    bcaSchedulerBroadcastLogsError,
  ]);

  const tbColumns = [
    {
      dataField: "date_added",
      text: "broadcast date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small className="underline lowercase">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "condition_type",
      text: "schedule type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.condition_type === "bca"
              ? "BCA"
              : row?.condition_type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth100"
            style={{
              background:
                row?.status === "sent"
                  ? "#0A701B"
                  : row?.status === "pending"
                  ? "#FFA500"
                  : "#D90000",
              color: "#fff",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "template_name",
      text: "template name",
      formatter: (_, row) => {
        let typeLabel = "NA";
        if (row?.is_email) {
          typeLabel = "Email";
        } else if (row?.is_push) {
          typeLabel = "Push";
        } else if (row?.is_whatsapp) {
          typeLabel = "WhatsApp";
        }

        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "wp_template_body",
                rowData: row,
              }));
            }}>
            <small className="gray underline">{typeLabel}</small>
            <br />
            {row?.template_name || "-"}
          </span>
        );
      },
    },
    {
      dataField: "schedule_broadcast_name",
      text: "schedule broadcast name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.schedule_broadcast_name || "-"}</span>
        );
      },
    },
    {
      dataField: "condition",
      text: "condition",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.condition || "-"}</span>;
      },
    },
    {
      dataField: "before_day",
      text: "sent before (days)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.before_day || "-"}</span>;
      },
    },
    {
      dataField: "after_day",
      text: "sent after (days)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.after_day || "NA"}</span>;
      },
    },
    // {
    //   dataField: "type",
    //   text: "type",
    //   formatter: (_, row) => {
    //     let typeLabel = "NA";
    //     if (row?.is_email) {
    //       typeLabel = "Email";
    //     } else if (row?.is_push) {
    //       typeLabel = "Push";
    //     } else if (row?.is_whatsapp) {
    //       typeLabel = "WhatsApp";
    //     }
    //     return <span className="tb-data">{typeLabel}</span>;
    //   },
    // },
    {
      dataField: "schedule_broadcast_description",
      text: "schedule broadcast description",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "description",
                rowData: row,
              }));
            }}>
            view
          </span>
        );
      },
    },
    // {
    //   dataField: "user_type",
    //   text: "user type",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.user_type || "NA"}</span>;
    //   },
    // },
    {
      dataField: "error",
      text: "failed reason",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.error || "NA"}</span>;
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}>
        <div className={`createNewCTOModalContainer ${"mod-width-50p"}`}>
          <ModalHeadAndClose
            title={
              modValues.modName === "wp_template" ||
              modValues.modName === "push_template"
                ? modValues.rowData?.name || "NA"
                : modValues.modName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.modName === "description" ||
          modValues.modName === "wp_template_body" ? (
            <div className="discussionModalMessage mt30">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html:
                    modValues.modName === "description"
                      ? modValues.rowData?.schedule_broadcast_description ||
                        "No Content Available"
                      : modValues.rowData?.whatsapp_template_body ||
                        "No Content Available",
                }}></p>
            </div>
          ) : modValues.modName === "wp_template" ||
            modValues.modName === "push_template" ? (
            <BCASchedulerTemplates
              template={
                modValues.modName === "wp_template" ? "whatsapp" : "push"
              }
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Scheduled Broadcast Logs"}
            isReload={() => getBcaSchedulerBroadcastLogs(filters)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="bca-scheduler"
            userInfoData={userInfoData}
            searchFilterApplied={searchFilterApplied}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            onClickReset={onResetFilters}
            isLoading={bcaSchedulerBroadcastLogsLoading}
            searchPlaceHolder="Search by member info, schedule broadcast name . . ."
            clickedCard="scheduled-broadcast-logs"
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
            {bcaSchedulerBroadcastLogsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={getAPIData.allData}
                tableColumns={tbColumns}
                tablePagination={getAPIData.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BCAScheduledBroadcastLogsStructure;
